import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, TextField, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import CheckoutLayoutItem from '../CheckoutLayoutItem';

function OrderNotes({ trackOrder, onAdjustedValue, onCheckoutUpdating }) {
  const { notes, checkoutAdjustResponse } = useSelector(({ order }) => ({
    notes: order?.notes,
    checkoutAdjustResponse: order?.checkoutAdjustResponse,
  }));

  const [currentNotes, setCurrentNotes] = useState('');

  const location = useLocation();
  const isCheckoutPage = location.pathname.includes('checkout');

  useEffect(() => {
    if (currentNotes !== '') {
      return;
    }

    if (notes && notes !== '') {
      setCurrentNotes(notes);
    } else if (checkoutAdjustResponse?.notes) {
      setCurrentNotes(checkoutAdjustResponse?.notes);
    }
  }, [notes, checkoutAdjustResponse]);

  const onNotesChange = ({ target }) => {
    const val = target?.value && target.value !== '' ? target.value : null;
    setCurrentNotes(val);
    if (onAdjustedValue) {
      onAdjustedValue('notes', val);
    }
  };

  return currentNotes !== '' || isCheckoutPage ? (
    <CheckoutLayoutItem
      title="Order Notes"
      subtitle="Details that the restaurant should know for your order."
      trackOrders={trackOrder}
    >
      {isCheckoutPage ? (
        <TextField
          inputProps={{ 'data-test-id': 'order-notes' }}
          data-test-id="order-notes"
          placeholder="You can type your order note here..."
          fullWidth
          multiline
          rows={4}
          value={currentNotes}
          disabled={onCheckoutUpdating}
          onChange={onNotesChange}
          name="orderNotes"
        />
      ) : (
        <Box>
          <Typography fontWeight={500}>Notes</Typography>
          <Typography color="text.secondary">{notes}</Typography>
        </Box>
      )}
    </CheckoutLayoutItem>
  ) : (
    <>&nbsp;</>
  );
}

export default OrderNotes;

OrderNotes.propTypes = {
  trackOrder: PropTypes.bool,
  onAdjustedValue: PropTypes.func,
  onCheckoutUpdating: PropTypes.bool.isRequired,
};

OrderNotes.defaultProps = {
  trackOrder: false,
  onAdjustedValue: null,
};
